export enum AuthModalMode {
  REGISTER = 'REGISTER',
  LOGIN = 'LOGIN',
  FORGOT_PASSWORD = 'FORGOT_PASSWORD',
  PHONE_NUMBER_FORM = 'PHONE_NUMBER_FORM',
}
